module.exports = __webpack_public_path__ + "static/media/CLY.849dafb4.png";